import React from 'react';
import { Page as Component } from '~/components/specifics/settings/company_vendors/construction_item_settings/Page';

export const Page: React.FC = () => <Component />;
